/**
 * IMPORTANT: The widget rendering system has been decommissioned.
 *
 * This file is maintained only to prevent breaking imports in existing third-party customizations.
 * New code should not use this component or the widget system.
 */

import { warnWidgetsDecommissioned } from "discourse/widgets/widget";

/**
 * This class is kept only for backward compatibility.
 *
 * @deprecated This class is part of the decommissioned widget system and should not be used anymore.
 */
class DummyHook {
  constructor() {
    warnWidgetsDecommissioned();
  }

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  hook() {}

  /**
   * @deprecated the widget rendering system was decommissioned
   */
  unhook() {}
}

export {
  DummyHook as WidgetClickHook,
  DummyHook as WidgetDoubleClickHook,
  DummyHook as WidgetClickOutsideHook,
  DummyHook as WidgetMouseDownOutsideHook,
  DummyHook as WidgetKeyUpHook,
  DummyHook as WidgetKeyDownHook,
  DummyHook as WidgetInputHook,
  DummyHook as WidgetChangeHook,
  DummyHook as WidgetMouseUpHook,
  DummyHook as WidgetMouseDownHook,
  DummyHook as WidgetMouseMoveHook,
  DummyHook as WidgetMouseOverHook,
  DummyHook as WidgetPointerOverHook,
  DummyHook as WidgetPointerOutHook,
  DummyHook as WidgetMouseOutHook,
  DummyHook as WidgetTouchEndHook,
  DummyHook as WidgetTouchStartHook,
  DummyHook as WidgetTouchMoveHook,
  DummyHook as WidgetDragHook,
};
